<template>
  <div class="media-gallery-flex" :class="layout" v-show="featureImages.length > 0">
    <a
      @click.stop
      v-for="(image, index) in filtered"
      :key="image.slug || image.url"
      :data-fslightbox="gallery"
      data-type="image"
      :data-medium-wrapper-slug="image.slug"
      :data-caption="generateCaptionHtml(image)"
      class="image-anchor"
      :href="image.url"
    >
      <img :src="image.thumbnail || image.url" class="image" :alt="image.title" />
      <div
        v-if="overlay && index === filtered.length - 1 && remainCount"
        class="image-overlay"
        :data-more-images="`${remainCount}+`"
      />
    </a>
    <a
      v-for="image in remainImages"
      class="is-hidden"
      :alt="image.title"
      :href="image.url"
      :key="`fslightbox-${image.slug || image.url}`"
      :data-fslightbox="gallery"
      data-type="image"
      :data-medium-wrapper-slug="image.slug"
      :data-caption="generateCaptionHtml(image)"
    />
  </div>
</template>

<script setup>
import { randomKey } from '@/utils/stringUtils.js'
import { computed, onMounted } from 'vue'
import { generateCaptionHtml } from '@/utils/mediaGallery.js'

const { featureImages, layout } = defineProps({
  featureImages: Array,
  layout: {
    type: String,
    default: 'row',
  },
  overlay: {
    type: Boolean,
    default: true,
  },
})

const images = { single: 1, row: 4, hotels: 5 }
const gallery = randomKey()
const filtered = computed(() => featureImages.slice(0, images[layout]))
const remainImages = computed(() => featureImages.slice(images[layout]))
const remainCount = computed(() => featureImages.length - filtered.value.length)

onMounted(() => {
  if (featureImages.length > 0) {
    refreshFsLightbox() // eslint-disable-line no-undef

    if (featureImages.length === 1) fixForSingleImageGalleryNotClosingOnBackgroundClick()
  }
})

function fixForSingleImageGalleryNotClosingOnBackgroundClick() {
  const instance = window.fsLightboxInstances[gallery]

  instance.props.onOpen = function (instance) {
    document.querySelector('.fslightbox-container').addEventListener('click', pointerEvent => {
      if (pointerEvent.target.classList.contains('fslightboxtt')) {
        instance.close()
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.media-gallery-flex {
  gap: 12px;

  .image {
    position: relative;
    width: 100%;
    aspect-ratio: 1;
    border-radius: 15px;
    object-fit: cover;
  }

  .image-anchor {
    display: flex;
    overflow: hidden;
    position: relative;
  }

  .image-overlay {
    font-size: $text-base;
  }
}

.media-gallery-flex.row {
  display: flex;

  .image-anchor {
    width: 83px;

    @media (max-width: $breakpoint-m) {
      width: 48px;
    }
  }
}

.media-gallery-flex.hotels {
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  .image-anchor:first-child {
    aspect-ratio: auto;
    grid-column: 1/-1;
  }
}
</style>
